// extracted by mini-css-extract-plugin
export default {"formTitle":"StudentInfoCard_formTitle__5qEvP","contentContainer":"StudentInfoCard_contentContainer__h1DAV"};